<template>
  <div
    class="group flex grow gap-2 overflow-hidden text-yapgray-700 dark:text-yapgray-100"
    :class="{
      'hover:text-primary-500 dark:hover:text-primary-dark-300': isClickable
    }"
  >
    <img
      v-if="pictureUri"
      class="h-12 w-12 shrink-0 rounded-full bg-yapgray-100 dark:bg-yapdarkgray-600"
      :src="pictureUri"
      alt=""
      loading="lazy"
    />
    <div
      class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-yapgray-300 dark:bg-yapdarkgray-600"
      v-else
    >
      {{ initials }}
    </div>
    <div class="shrink grow overflow-hidden">
      <div class="text-md overflow-hidden text-ellipsis whitespace-nowrap font-semibold leading-6">
        {{ name }}
      </div>
      <div
        class="text-yapgray-600 dark:text-yapgray-400"
        :class="{ 'group-hover:text-primary-500/80 dark:group-hover:text-primary-dark-300/80': isClickable }"
        data-testid="account-amount"
        v-if="displayAmount"
      >
        <YapAmount
          :amount="amount"
          :currency="currency"
          :show-negative-sign="true"
          :show-positive-sign="false"
          :clickable="canHideAmount"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import YapAmount from '@/components/YapAmount.vue';

const props = defineProps<{
  name: string;
  currency?: string;
  amount?: number | string;
  pictureUri?: string;
  isClickable?: boolean;
  canHideAmount?: boolean;
}>();

// Create a reactive variable to track whether to display the amount
const displayAmount = computed(() => props.amount !== undefined);

const initials = computed(() => {
  const parts = props.name.split(' ');
  // returns either the initials or the first 2 letters
  if (parts.length > 1) {
    return `${parts[0].slice(0, 1)}${parts[1].slice(0, 1)}`;
  } else {
    return props.name.substring(0, 2);
  }
});
</script>
